import { Component, OnInit } from '@angular/core';
import { bmxurl } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AvailabilityReq, Payment, Customer } from '../../PackageClasses';
import { customer } from 'src/types/customer';
import { booking_returndata } from 'src/types/booking_returndata';
import { MessageService } from 'primeng/api';
import { cExtra } from 'src/types/extra';
import { cPackageExtra } from 'src/types/packageExtra';
import { BusyService } from '../_services/busy.service';
import { admission } from 'src/types/admission';
import { cBookingfee } from 'src/types/bookingfee';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';
import { DomSanitizer } from '@angular/platform-browser';
import { conf_returndata } from 'src/types/conf_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { birthdayanswers, questionanswers } from 'src/types/questionanswers';
import { bookingquestionitem } from 'src/types/bookingquestion';
import { GlobalService } from '../_services/global.service';
import { cMembershipDiscountvalidate, cMembershipOpenDiscountvalidate } from 'src/types/discountvailidate';
import { membership_returndata } from 'src/types/membership_returndata';
import { membershipadmission } from 'src/types/membershipadmissions';
import { membershipsale } from 'src/types/membershipsale';
import { membershipsummary } from 'src/types/membershipsummary';
import { memberadmission } from 'src/types/memberadmissions';
import { payment_returndata } from 'src/types/payment_returndata';
import { cRefund, refund } from 'src/types/refund';

@Component({
  selector: 'app-editcustomerschedeuledsession',
  templateUrl: './editcustomerschedeuledsession.component.html',
  styleUrls: ['./editcustomerschedeuledsession.component.css']
})
export class EditcustomerschedeuledsessionComponent  implements OnInit {

  //#region  Variables
  id: string;
  BookingComplete: boolean = false;
  packages: any[] = [];
  packages1: any[] = [];
  SelectedPackage: any;
  SelectedResources: any[] = []
  SelectedDate: Date;
  startTimes: any;
  startTimesFiltered: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateCustomer: any;
  PaymentTypes: any = [];
  selectedPayment: any;
  packageExtras: cPackageExtra[];
  selectedPackageExtras: cExtra[];

  BookingDateAndTime: string = "";
  BookingPackage: string = "";
  BookingAdmissions: string = "";
  BookingAddress: string = "";
  BookingEmail: string = "";
  BookingMobile: string = "";
  BookingValue: string = "";
  Itinerary: string = "";
  bookingExtras: string = "";

  paymentValueValid: boolean = true;
  paymentTypeValid: boolean = true;
  paymentValueExceededValid: boolean = true;
  paymentDepositValid: boolean = true;
  validPaymentAmount: number = 0;

  AllValid: boolean =true;
  CustomerAllValid: boolean =true;

  PackageAdmissions: admission[];
  SelectedAdmissions: any[] = [];

  PackageHeader: string = "Select a Package";
  CalendarHeader: string = "Select a Date";
  AdmissionHeader: string = "Select your Admissions";
  TimeHeader: string = "Select a Time";
  CustomerHeader: string = "Create a Customer";
  PaymentHeader: string = "Add a Payment";
  ExtrasHeader: string = "Select Extras";
  SelResourceHeader: string = "Please Select";

  packageSelected: Boolean;
  admissionsSelected: Boolean;
  dateSelected: Boolean;
  timeSelected: Boolean;
  customerSelected:Boolean;
  paymentSelected:Boolean;
  extraSelected: Boolean;
  notesSelected: Boolean;
  partyroomsSelected: Boolean;
  bookingQuestionsSelected: Boolean;

  packageActive: Boolean;
  admissionsActive: Boolean;
  dateActive: Boolean;
  timeActive: Boolean;
  customerActive:Boolean;
  paymentActive:Boolean;
  extraActive: Boolean;
  notesActive: Boolean;
  partyroomsActive: Boolean;
  partyroomsVisible: Boolean;
  bookingQuestionsActive: Boolean;

  //Customer
  firstName: string = "";
  lastName: string = "";
  address1: string = "";
  address2: string = "";
  town: string = "";
  postCode: string = "";
  email: string = "";
  mobile: string = "";
  dob: Date = new Date(1900, 1, 1);

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  Address1Valid: boolean = true;
  TownValid: boolean = true;
  PostCodeValid: boolean = true;
  EmailValid: boolean = true;
  MobileValid: boolean = true;
  //NewBooking = {} as booking;

  EmailFormatValid: boolean = true;
  MobileFormatValid: boolean = true;

  stateOptions: any[];
  stateOptionsMin: any[];
  statePayOptions: any[];

  ProvideMinimalPersonalData: boolean = true;

  MembershipResponse: any;

  //payment
  paymentAmount: number;
  maxPayment: number;

  searchCriteria: string;
  customersResult: any;

  disgnosticsMode: boolean = true;
  ShowCustomerDetails: boolean = false;

  makeABookingHeader: string = "Make a Booking"
  notes: string;

  SelectedSeletableResource: any[] = [];
  SelectedSeletableResourceBool: boolean[] = [];

  customerSelectedResources: any[] = [];
  includesComplexResources: boolean = false;
  includesOptionalResources: boolean = false;

  systemChoosesAllResources: boolean = true;

  validselection: boolean[] = [];

  totalAdmissions: number = 0;

  maxadmissions: number = 0;
  minadmissions: number = 0;

  totalAdmissionInRange: boolean;
  PackageHasExtras: boolean;

  MinimumValidPayment:number = 0;
  MustIncludePass: boolean = true;

  httpResponse: any;
  httpMembershipResponse: any;
  BookingFee: cBookingfee;

  MembershipComplete: boolean = false;
  MembershipSummary: membershipsummary;
  
  packageGroups: any[];

  checked: any[] = [];
  popular: any;

  showDiscount: boolean = false;
  discountCode: string = "";

  BookingFeeAdddedOn: number = 0;
  DiscountTakenOff: number = 0;

  showPrintConfirmations: boolean = false;
  confHTML: string = "";

  TotalExtras: number = 0;
  minimumDiscount: number = 0;

  BookingPayments: Payment[] = [];
  totalPayments: number;

  showDeferReason: boolean = false;
  deferNotes: string = "";
  AvailabilityReq = {} as AvailabilityReq;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  stateOptionAllergy: any[];
  birthdayitems: birthdayanswers[] = [];

  mustanswerallergies: boolean[] = [];
  mustanswerbirthdays: boolean[] = [];
  mustanswernumber: boolean[] = [];
  mustanswerfreetext: boolean[] = [];
  mustanswermultichoicesingleanswer: boolean[] = [];
  mustanswermultichoicemultianswer: boolean[] = [];
  mustanswerdate: boolean[] = [];

  questionAnswers: questionanswers[] = [];
  questionAnswer: questionanswers;

  bookingFreeTextAnswer: string = "";
  bookingallergyanswer: string = "";
  bookingnumberanswer: number = 0;
  bookingdateanswer: Date = null;
  allergyAnswer:boolean[] = [];
  bookingmultichoicesingleanswer: bookingquestionitem = null;
  bookingmultichoicemultianswer: bookingquestionitem[] = [];
  showVoucher: boolean = false;
  voucherCode: string = "";
  voucherpin: string = "";

  timetobetried: string = "";

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  allergyOptions: any[] = [{ name: 'Yes', value: true }, { name: 'No', value: false}];

  CurrentDate = new Date();//new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0,0,0,0);

  VoucherComplete: boolean = false;

  SummaryItinerary: boolean = false;

  allQuestionsValid: boolean = true;
  linkedAdmissionMessageShown: boolean = false;
  showWarning: boolean = false;
  WarningMessage: string = "";
  totalDiscount: number = 0;

  paymentButtonLocked: boolean = false;

  stateOptionOpenDiscount: any[];
  stateGenderOptions: any[];

  openDiscount: boolean = false;

  chosenDiscountAmount: number = 0;

  showVCWarning: boolean = false;
  VCWarningMessage: string = "";

  venueClosings: any[] = [];

  caldays: any[] = [];
  calmonths: any[] = [];
  calyears: any[] = [];

  DOBDay: any[] = [];
  DOBMonth: any[] = [];
  DOBYear: any[] = [];

  DOBIsValid: boolean = true;
  dobage: any[] = [];

  ShowAge: boolean = false;
  ShowDOB: boolean = false;
  ShowGender: boolean = false;
  ShowInterests: boolean = false;

  oldDepositValue: number = 0;

  UseIntervalAvailability: boolean = false;

  NewAllowedMin: number = 0;

  ListMemberships: any[];

  ViewMemberships: boolean = true;
  ViewAdmissions: boolean = false;
  ViewDetails: boolean = false;
  ViewCustomer: boolean = false;
  ViewPayment: boolean = false;

  MembershipAdmissions: any[] = [];

  MemberAdmissions: any[] = [];
  DetailedMembershipAdmissions: any[] = [];

  thisMembershipSale: membershipsale;

  //What has actually been taken, net of refunds - refunds come back as negative rows in the
  //payments list, which is what the Payments table renders.
  get totalPaid(): number {
    if (this.thisMembershipSale == null || this.thisMembershipSale.payments == null) {
      return 0;
    }

    let paid = 0;

    this.thisMembershipSale.payments.forEach(p => {
      paid += (p.amount ?? 0);
    });

    return this.roundToPence(paid);
  }

  //What is still owed on this sale. This is worked out here rather than taken from the
  //sale's outstanding figure: that figure is not re-cut when a discount is applied, so it
  //left the Payment Value box asking for the pre-discount amount. A deferred sale also
  //comes back with outstanding sat at 0, which used to hide the Add Payment panel
  //altogether and left no way of taking the money afterwards.
  get amountOwed(): number {
    if (this.thisMembershipSale == null) {
      return 0;
    }

    if (this.thisMembershipSale.total != null) {
      return this.roundToPence(this.thisMembershipSale.total - this.totalPaid);
    }

    return this.thisMembershipSale.outstanding ?? 0;
  }

  private roundToPence(value: number): number {
    return Math.round(value * 100) / 100;
  }
  
  MembershipSaleResponse: any;

  validdob: boolean[]  = [];
  validname: boolean[]  = [];

  membershipSummary: membershipsummary = {} as membershipsummary;

  ShowTitle: boolean = true;
  selectedMembership: any;

  firstNameEditValid: boolean = true;
  lastNameEditValid: boolean = true;
  Address1EditValid: boolean = true;
  TownEditValid: boolean = true;
  PostCodeEditValid: boolean = true;
  EmailEditValid: boolean = true;
  MobileEditValid: boolean = true;
  EmailFormatEditValid: boolean = true;
  MobileFormatEditValid: boolean = true;

  ShowCustomerSearch: boolean = false;
  CustomerHasBeenEdited: boolean = false;

  AdmissionToAdd: admission = {} as admission;
  AdmissionList: admission[] = [];

  Total: number = 0;

  membershipEmailTemplateID: string = "";

  CurrentLoggedInUser: any;

  displayModalRefund: boolean = false;
  RefundPayment: number;
  RefundReason: string;
  RefundPaymentId: string;

    RefundPaymentValid: boolean = true;
    RefundTextValid: boolean = true;

  //#endregion

  noTemplate()
  {
    this.messageService.add({severity:'warn', summary:'No Template', detail: 'There is no Email Template set for this Membership, please assign one and try again.'});
  }

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private busyService: BusyService, private globalService: GlobalService) { 
      this.stateOptions = [{ label: 'Use full personal details', value: false }, { label: 'Use limited personal details', value: true}]; 
      this.stateOptionsMin = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}];    
      this.stateOptionAllergy = [{ label: 'Yes', value: true }, { label: 'No', value: false}];  
      this.stateOptionOpenDiscount = [{ label: 'Enter Discount Value', value: true }, { label: 'Enter Discount Code', value: false}]; 
      this.stateGenderOptions =  [{ label: 'Rather not say', value: 'NOT STATED' }, { label: 'Male', value: 'MALE'}, {label: 'Female', value: 'FEMALE'}]; 
      
      this.ShowTitle = true;

      this.dobage = [
        {name:'0 to 3 months', value:'0 to 3 months'},
        {name:'4 to 6 months', value:'4 to 6 months'},
        {name:'6 to 12 months', value:'6 to 12 months'},
        {name:'1', value:'1'},
        {name:'2', value:'2'},
        {name:'3', value:'3'},
        {name:'4', value:'4'},
        {name:'5', value:'5'},
        {name:'6', value:'6'},
        {name:'7', value:'7'},
        {name:'8', value:'8'},
        {name:'9', value:'9'},
        {name:'10', value:'10'},
        {name:'11', value:'11'},
        {name:'12', value:'12'},
        {name:'13', value:'13'},
        {name:'14', value:'14'},
        {name:'15', value:'15'},
        {name:'16', value:'16'},
        {name:'17', value:'17'},
        {name:'18', value:'18'},
        {name:'Over 18', value:'Over 18'}
      ];

      this.caldays =  [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'},
        {name: '13', value:'13'},
        {name: '14', value:'14'},
        {name: '15', value:'15'},
        {name: '16', value:'16'},
        {name: '17', value:'17'},
        {name: '18', value:'18'},
        {name: '19', value:'19'},
        {name: '20', value:'20'},
        {name: '21', value:'21'},
        {name: '22', value:'22'},
        {name: '23', value:'23'},
        {name: '24', value:'24'},
        {name: '25', value:'25'},
        {name: '26', value:'26'},
        {name: '27', value:'27'},
        {name: '28', value:'28'},
        {name: '29', value:'29'},
        {name: '30', value:'30'},
        {name: '31', value:'31'}
      ];
          
      this.calmonths = [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'}
      ];
      
      for(let i = 2050; i > 1920; i--)
        {
          let thisYear = new Date().getFullYear();
          if(i <= thisYear)
          {
            this.calyears.push({name: i.toString(), value: i.toString()});
          }
        }

        this.thisMembershipSale = {
          id: null,
          saleid: null,
          saleidhr: null,
          membershiptypeid: "",
          memberships: [],
          creationdate: new Date(),
          startdate: new Date(),
          lengthinmonths: 12,
          enddate: new Date,
          customer: null,
          payments: [],
          awaitingpayment: false,
          deferredpayment: false,
          disabled: false,
          venueid: this.VenueID,
          outstanding: 0,
          totaldiscounts: 0,
          totalvenuedeposit: 0,
          totalpublicdeposit: 0,
          totalpayments: 0,
          bookingfee: 0,
          discounts: null,
          total: 0,
          membershipid: '',
          salesprice: 0
        }

        // this.http.get(bmxurl + "admission/" + this.VenueID + "/" + this.id).subscribe(response => {
        //   this.httpResponse = response
        //   if(this.httpResponse.succeeded)
        //   {
        //     this.AdmissionList = (response as admission_returndata).data;
        //   }
        //   else
        //   {
        //     this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Admissions, error: ' + this.httpResponse.messages[0]});
        //   }
        // }, error => {
        //   this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Admissions, error: ' + error.messages});
        // });
  }

  checkIfRefundallowed()
  {
    if(this.CurrentLoggedInUser.accesscontrol.name == 'Venue Administrator')
    {
      return true;
    }
    else
    {
      return false;
    }
  }

    DoValidCheck()
  {
    let AllValid = true;

    if(this.RefundPayment == null || this.RefundPayment == 0)
    {
      AllValid = false;
      this.RefundPaymentValid = false;
    }
    else
    {
      this.RefundPaymentValid = true;
    }

    if(this.RefundReason == null || this.RefundReason == "")
    {
      AllValid = false;
      this.RefundTextValid = false;
    }
    else
    {
      this.RefundTextValid = true;
    }

    return AllValid;
  }

    doRefund()
    {
      if (this.DoValidCheck())
      {
        let newRefund: cRefund={
          venueid: this.VenueID,
          paymentid: this.RefundPaymentId,
          reason: this.RefundReason,
          amount: this.RefundPayment,
          notes: "",
          disabled: false
        }
  
        this.busyService.busy();
        this.http.post<refund>(bmxurl + "/refund", newRefund).subscribe(response => {
          this.httpResponse = response
  
          if(this.httpResponse.succeeded)
          {
            //Refunding puts money back on the balance, so the payment panel has to be
            //recalculated from the returned sale - it used to keep the figure worked out
            //when the screen loaded, which showed nothing left to pay.
            this.applyUpdatedSale((response as any).data);
            this.refreshSaleFromServer();

            this.membershipSummary.paid = this.totalPaid;


           this.displayModalRefund = false;
  
           this.messageService.add({severity:'success', summary:'Saved', detail:'Refund successful, the refund has been passed to the card issuer and will be processed by them in accordance to their refund policy.'});
           this.RefundReason = "";

            this.busyService.idle();
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Not Saved', detail: this.httpResponse.messages[0]});
            this.busyService.idle();
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail: this.httpResponse.messages[0]});
          this.busyService.idle();
      })
      
      }
    }
    

  setupRefund(paymentID: string)
  {
    if(this.checkIfRefundallowed())
    {
      let payment: Payment;
      this.RefundPaymentId = paymentID;

      this.http.get(bmxurl + "Payment/" + this.VenueID + "/" + paymentID).subscribe(response => {
        payment = (response as payment_returndata).data;

        this.RefundPayment = payment.amount;
      }, error => {
      })

      this.displayModalRefund = true;
    }
    else
    {
      this.messageService.add({severity:'error', summary:'Not Allowed', detail: 'You do not have authority to refund this payment, please speak to your manager.'});
    }
  }

  //Each member carries a back-pointer to the sale it belongs to, so anything that reads a
  //member on its own - the session register, for one - can get back to the sale it came from.
  //Stamped again immediately before each save, not just when the member is built: a new sale
  //has no membershipid until the API has assigned one, so the value present at build time is
  //null on the first save and only becomes real once the sale has come back from the server.
  stampMembershipIdOnMembers()
  {
    if(this.thisMembershipSale == null || this.thisMembershipSale.memberships == null)
      return;

    this.thisMembershipSale.memberships.forEach(adm => {
      adm.membershipid = this.thisMembershipSale.membershipid;
    });
  }

  savemembershipsale(disabled: boolean = false){

    this.thisMembershipSale.disabled = disabled;

    this.stampMembershipIdOnMembers();

    this.http.put<any>(bmxurl + "/membership", this.thisMembershipSale).subscribe(response => {
      this.MembershipSaleResponse = response
      if(this.MembershipSaleResponse.succeeded)
      {
        //this.messageService.add({severity:'success', summary:'Success', detail: 'Membership Saved'});
        this.thisMembershipSale = this.MembershipSaleResponse.data;

        if (disabled == false)
        {
          this.MembershipComplete = true;
          this.ViewPayment = false;
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Error Saving Membership, error: ' + this.MembershipSaleResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
    })
  }

  doneAdmissions(){

    var index = 0;

    this.SelectedAdmissions.forEach(adm => {
      for(var i = 0; i < adm.numberofadmissions; i++)
      {
        index++;
        var newAdm: memberadmission = {
          id: adm.id,
          index: index,
          name: adm.name,
          membershipadmissionid: adm.membershipadmissionid,
          min: adm.min,
          max: adm.max,
          price: adm.price,
          detailsrequired: adm.detailsrequired,
          admissionid: adm.admissionid,
          membername: "",
          //1/1/1900 sentinel - month is zero based, so 1 here would be February.
          memberdob: new Date(1900, 0, 1),
          admissionsindex: 0,
          participant: true,
          disabled: false,
          inprogress: true,
          membershipid: this.thisMembershipSale.membershipid
        }

        this.DetailedMembershipAdmissions.push(newAdm);
      }
    }
    );

    this.DetailedMembershipAdmissions.forEach(adm => {
      this.validname.push(false);
      this.validdob.push(false);
    });

    this.ViewAdmissions = false;
    this.ViewDetails = true;


  }

  validdatedetails(){
    let allvalid = true;

    this.DetailedMembershipAdmissions.forEach(adm => {
      if(adm.membername == null || adm.membername == "")
      {
        this.validname[adm.index - 1] = true;
        allvalid = false;
      }

      if(adm.memberdob == null || adm.memberdob == "" || this.isValidDate(adm.memberdob) == false)
      {
        this.validdob[adm.index - 1] = true;
        allvalid = false;
      }
    });

    if(allvalid)
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  doneDetails(){

    if(this.validdatedetails()){
      this.ViewDetails = false;
      this.ViewCustomer = true;

      this.thisMembershipSale.memberships = this.DetailedMembershipAdmissions;
    }
    else
    {

    }
  }

  getMemberships(){
      this.http.get(bmxurl + "membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ListMemberships = (response as membership_returndata).data;
  
          if ((response as membership_returndata).messages.length > 0)
          {
            (response as membership_returndata).messages.forEach(error => {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
            });
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
      });
  }

  sendPaymentLink(){

    // this.thisMembershipSale.payments = null;
    // this.thisMembershipSale.awaitingpayment = true;

    // this.http.post<any>(bmxurl + "/Payment", this.thisMembershipSale).subscribe(response => {
    //  this.MembershipResponse = response
    //  this.BookingDateAndTime = new Date(this.MembershipResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

    //  this.BookingPackage = this.MembershipResponse.data.packageName;
    
    //  this.http.get<any>(bmxurl + "sendpaymentlink/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
    //   this.httpResponse = response;

    //   if(!this.httpResponse.succeeded)
    //   {
    //     this.messageService.add({severity:'error', summary:'Failure', detail: this.httpResponse.messages[0]});
    //   }
    //   else
    //   {
    //     if(this.MembershipResponse.data.payments != null)
    //     {
    //       if(this.MembershipResponse.data.payments.length > 0)
    //       {
    //         this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent'});
    //       }
    //       else
    //       {
    //         this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
    //       }
    //     }
    //     else
    //     {
    //       this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
    //     }
    //     this.DoSummary(this.MembershipResponse.data);
    //   }

    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
    // })

    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to defer payment'});
    // })

  }

  isValidDate(dateString: string): boolean {
     //check if date is valid
      let date = new Date(dateString);
      return date instanceof Date && !isNaN(date.getTime());
  }

  IsToday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  doReferralNote(){
  //   this.showDeferReason = false;

  //   this.thisMembershipSale.payments = null;
  //   this.thisMembershipSale.deferredpayment = true;

  //   this.http.post<customer>(bmxurl + "/deferpayment", this.thisMembershipSale).subscribe(response => {
  //     this.MembershipResponse = response
  //     this.BookingDateAndTime = new Date(this.MembershipResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

  //     this.BookingPackage = this.MembershipResponse.data.packageName;
    
  //     this.DoSummary(this.MembershipResponse.data);

  //   }, error => {
  //   })
   }

  genRandomNum()
  {
    return Math.floor((Math.random()*10000)+1).toString();
  }

  // doneVoucher()
  // {  
  //   this.busyService.busy();

  //   let newCustomer: any;

  //   newCustomer = this.NewBooking.customer;
    
  //   let dv: cVouchervalidate = {
  //     booking: this.NewBooking,
  //     vouchercode: this.voucherCode.trim(),
  //     voucherpin : this.voucherpin 
  //   }

  //   this.http.post<booking_returndata>(bmxurl + "/VoucherValidate", dv).subscribe(response => {
  //     this.httpResponse = response
  //     if (this.httpResponse.succeeded == true) {
  //       this.messageService.add({ severity: 'success', summary: 'Voucher Added', detail: 'Your voucher has been added' });

  //       this.showDiscount = false;
  //       this.discountCode = "";

  //       this.showVoucher = false;
  //       this.voucherCode = "";

  //       this.NewBooking = (response as booking_returndata).data;

  //       this.BookingPayments = this.NewBooking.payments;

  //       this.NewBooking.customer = newCustomer;

  //       if(this.NewBooking.PublicBooking)
  //       {
  //         this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
  //       }
  //       else{
  //         this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
  //       }

  //       if(this.NewBooking.totalpayments >= this.NewBooking.totalpublicdeposit)
  //       {
  //         this.DoSummary(this.NewBooking);
  //         this.BookingComplete = true;
  //       }
  //       this.busyService.idle();
  //     }
  //     else
  //     {
  //       this.busyService.idle();
  //       this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
  //     }
  //   }, error => {
  //     this.busyService.idle();
  //     this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.error.messages[0] });
  //   })
  // }

  //The versions above were commented out copies of the booking flow - they worked against
  //this.NewBooking and the /DiscountValidate endpoints, neither of which apply to a
  //membership sale, so the Apply Discount buttons called methods that did not exist and
  //did nothing. These follow the membership endpoints used on the sell screen.
  doneDiscount(){
    if (this.discountCode == null || this.discountCode.trim() == "") {
      this.messageService.add({ severity: 'warn', summary: 'No Code', detail: 'Please enter a discount code.' });
      return;
    }

    let dv: cMembershipDiscountvalidate = {
      membership: this.thisMembershipSale,
      discountcode: this.discountCode.trim()
    }

    this.busyService.busy();

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidateMembership", dv).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.applyUpdatedSale((response as booking_returndata).data);
        this.refreshSaleFromServer();
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: this.httpResponse.messages[0] });
      }
      this.busyService.idle();
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages?.[0] ?? 'Could not apply the discount.' });
      this.busyService.idle();
    })
  }

  doneOpenDiscount(){
    if (this.chosenDiscountAmount == null || this.chosenDiscountAmount <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Amount', detail: 'Please enter a discount amount.' });
      return;
    }

    let dv: cMembershipOpenDiscountvalidate = {
      membership: this.thisMembershipSale,
      value: this.chosenDiscountAmount
    }

    this.busyService.busy();

    this.http.post<any>(bmxurl + "/OpenDiscountMembership", dv).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.showDiscount = false;
        this.chosenDiscountAmount = 0;

        this.applyUpdatedSale((response as any).data);
        this.refreshSaleFromServer();
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: this.httpResponse.messages[0] });
      }
      this.busyService.idle();
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages?.[0] ?? 'Could not apply the discount.' });
      this.busyService.idle();
    })
  }

  removeDiscount()
  {
    this.busyService.busy();

    this.thisMembershipSale.discounts = null;

    this.stampMembershipIdOnMembers();

    this.http.put<booking_returndata>(bmxurl + "/savemembership", this.thisMembershipSale).subscribe(response => {
      this.httpResponse = (response as booking_returndata);

      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Removed', detail: 'Your discount has been removed' });
        this.applyUpdatedSale(this.httpResponse.data);
        this.refreshSaleFromServer();
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Removed', detail: this.httpResponse.messages[0] });
      }
      this.busyService.idle();
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Removed', detail: error.messages?.[0] ?? 'Could not remove the discount.' });
      this.busyService.idle();
    })
  }

  //The sale that comes back carries the recalculated totals, so the figures the payment
  //panel works from have to be taken from it rather than left as they were.
  private applyUpdatedSale(sale: any): void {
    if (sale == null) {
      return;
    }

    //Not every endpoint answers with the sale - a refund answers with the refund - and
    //binding the panel to one of those would empty the screen.
    if (sale.saleid == null && sale.total == null) {
      return;
    }

    let previous = this.thisMembershipSale;

    this.thisMembershipSale = sale;

    //A rebuilt sale does not always come back carrying the fields that identify it. Losing
    //those means the next call cannot tie the sale to its type or its record, which is what
    //the API reports as "Membership type not found".
    if (previous != null) {
      if (this.thisMembershipSale.membershiptypeid == null) {
        this.thisMembershipSale.membershiptypeid = previous.membershiptypeid;
      }

      if (this.thisMembershipSale.saleid == null) {
        this.thisMembershipSale.saleid = previous.saleid;
      }

      if (this.thisMembershipSale.membershipid == null) {
        this.thisMembershipSale.membershipid = previous.membershipid;
      }

      if (this.thisMembershipSale.venueid == null) {
        this.thisMembershipSale.venueid = previous.venueid;
      }

      if (this.thisMembershipSale.customer == null) {
        this.thisMembershipSale.customer = previous.customer;
      }
    }

    //The API hands dates back as strings, but the calendars on the members tab bind to
    //Date objects - the same conversion the initial load does.
    if (this.thisMembershipSale.memberships != null) {
      this.thisMembershipSale.memberships.forEach(m => {
        if (m.memberdob != null) {
          m.memberdob = new Date(m.memberdob);
        }

        if (m.questionnaire != null && m.questionnaire.bookingquestions != null) {
          m.questionnaire.bookingquestions.forEach(bq => {
            if (bq.questiontype == "DATE" && bq.answers != null) {
              bq.answers.dateanswer = new Date(bq.answers.dateanswer);
            }
          });
        }
      });
    }

    this.Total = this.thisMembershipSale.total;
    this.paymentAmount = this.thisMembershipSale.total;
    this.validPaymentAmount = this.amountOwed;
  }

  //The endpoints that change a sale rebuild it rather than answering with the stored
  //record, so the panel is re-read from the API afterwards and every figure on it comes
  //from one authoritative sale.
  private refreshSaleFromServer(): void {
    this.busyService.busy();

    this.http.get(bmxurl + "membership/" + this.VenueID + "/" + this.id).subscribe(response => {
      let sale = (response as any).data;

      if (sale != null) {
        this.applyUpdatedSale(sale);
        this.membershipSummary.paid = this.totalPaid;
      }

      this.busyService.idle();
    }, error => {
      //Keep what the change handed back rather than blanking the panel.
      this.busyService.idle();
    })
  }

  //The payment type dropdown calls this to release the Add Payment button - it was bound
  //in the template but never written here, so changing the type after a payment threw.
  resetlock()
  {
    this.paymentButtonLocked = false;
  }

  displayDiscount(){
    this.showDiscount = !this.showDiscount;
  }

  displayVoucher(){
    this.showVoucher = !this.showVoucher;
  }
  
  addselectedCustomer(passCustomer){
    this.searchCriteria = "";

    this.CustomerHeader = "Customer: " +  passCustomer.firstName + "  " + passCustomer.lastName;

    let newCustomer: Customer = {
      id: null,
      customerid: null,
      firstName: passCustomer.firstName,
      lastName: passCustomer.lastName,
      fullName: passCustomer.firstName + " " + passCustomer.lastName,
      address1: passCustomer.address1,
      address2: passCustomer.address2,
      townCity: passCustomer.townCity,
      postCode: passCustomer.postCode,
      email: passCustomer.email,
      mobile: passCustomer.mobile,
      dob: this.dob,
      venueId: this.VenueID,
      disabled: false,
      bookingid: null
    }
    
    this.customersResult = null;
    this.searchCriteria = "";

    this.thisMembershipSale.customer = newCustomer;

    this.ShowCustomerSearch = false;

  }

  doneMembership(mmbrshp){

    this.totalPayments = 0;

    this.ViewMemberships = false;
    this.ViewAdmissions = true;

    this.MembershipAdmissions = mmbrshp.membershipadmissions;

    this.MembershipAdmissions.forEach(adm => {
      var newAdm: membershipadmission = {
        id: adm.id,
        index: adm.index,
        name: adm.name,
        membershipadmissionid: adm.membershipadmissionid,
        min: adm.min,
        max: adm.max,
        price: adm.price,
        detailsrequired: adm.detailsrequired,
        admissionid: adm.admissionid,
        numberofadmissions: adm.min,
        participant: adm.participant,
        membershiptypeid: adm.membershiptypeid,
        questionnaire: adm.questionnaire,
        inprogress: adm.inprogress,
        admissionsindex: adm.admissionsindex
      }

      this.SelectedAdmissions.push(newAdm);

      this.thisMembershipSale.membershiptypeid = mmbrshp.id;
    });

  }

  addCustomer(){
    //Check Search field for postcode

    if(this.valid_postcode(this.searchCriteria))
    {
      this.postCode = this.searchCriteria
    }
    else if(this.valid_mobile(this.searchCriteria))
    {
      //Check Telephone number
      this.mobile = this.searchCriteria
    }
    else if(this.searchCriteria.includes("@"))
    {
      this.email = this.searchCriteria
    }
    else
    {
      this.lastName = this.searchCriteria
    }


    this.ShowCustomerDetails = true;
  }

  valid_postcode(postcode) {
    if(this.searchCriteria != null && this.searchCriteria != "")
    {
        postcode = postcode.replace(/\s/g, "");
        var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
        return regex.test(postcode);
    }
    else
    {
      return true;
    }
  }

  valid_mobile(postcode) {
    if(this.searchCriteria != null && this.searchCriteria != "")
      {
        postcode = postcode.replace(/\s/g, "");
        var regex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        return regex.test(postcode);
      }
      else 
      {
        return true;
      }
  }

  ngOnInit(): void {

    this.id = this.route.snapshot.paramMap.get('id');

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    let userid = localStorage.getItem("SmartUserID");
    
    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        this.CurrentLoggedInUser = user;

        this.http.get(bmxurl + "paymenttypes").subscribe(response => {
          if((response as paymenttypes_returndata).succeeded)
          {
            this.PaymentTypes = (response as paymenttypes_returndata).data;

            this.PaymentTypes = this.PaymentTypes.filter(pt => pt.system == false);
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
        })
            
        this.http.get(bmxurl + "membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ListMemberships = (response as membership_returndata).data;
  
          if ((response as membership_returndata).messages.length > 0)
          {
            (response as membership_returndata).messages.forEach(error => {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
            });
          }

          this.http.get(bmxurl + "membership/" + this.VenueID + "/" + this.id).subscribe(response => {
          this.httpMembershipResponse =  (response as any)
          this.thisMembershipSale = this.httpMembershipResponse.data;

          this.validPaymentAmount = this.amountOwed;

          this.thisMembershipSale.memberships.forEach(m => {
           if(m.questionnaire != null && m.questionnaire.bookingquestions != null && m.questionnaire.bookingquestions.length > 0)
           {
             m.questionnaire.bookingquestions.forEach(bq => {
              if(bq.questiontype == "DATE")
              {
                bq.answers.dateanswer = new Date(bq.answers.dateanswer);
              }
             });
           }
          });

          this.membershipSummary.PIN = this.httpMembershipResponse.data.membershippin;
          this.membershipSummary.membershipidhr = this.httpMembershipResponse.data.salesid;
          this.membershipSummary.startTime = this.httpMembershipResponse.data.startdate;
          this.membershipSummary.endTime = this.httpMembershipResponse.data.enddate;

          let memTypeID = this.httpMembershipResponse.data.membershiptypeid;

          this.ListMemberships.forEach(m => {
            if(m.membershiptypeid == memTypeID)
            {
              this.membershipSummary.membershipType = m.name;
              this.membershipEmailTemplateID = m.emailtemplate.emailtemplateid;
            }
         });

          this.membershipSummary.admissions = "";
          this.httpMembershipResponse.data.memberships.forEach(adm => {
            if(adm.detailsrequired)
            {
              this.membershipSummary.admissions += adm.membername + " (" + new Date(adm.memberdob).toLocaleDateString().padStart(10, '0') + "), ";
            }
            else
            {
              this.membershipSummary.admissions += adm.membername + ", ";
            }

            //adm.questionnaire.
          });

          this.membershipSummary.admissions = this.membershipSummary.admissions.substring(0, this.membershipSummary.admissions.length - 2);

          this.membershipSummary.customerName = this.httpMembershipResponse.data.customer.firstName + " " + this.httpMembershipResponse.data.customer.lastName;
          this.membershipSummary.customerAddress = this.httpMembershipResponse.data.customer.address1 + " " + this.httpMembershipResponse.data.customer.address2 + "\n" + this.httpMembershipResponse.data.customer.townCity + "\n" + this.httpMembershipResponse.data.customer.postCode;

          this.membershipSummary.customerMobile = this.httpMembershipResponse.data.customer.mobile;
          this.membershipSummary.customerEmail = this.httpMembershipResponse.data.customer.email;

          this.membershipSummary.paid = this.totalPaid;

          this.thisMembershipSale.memberships.forEach(element => {
            element.memberdob = new Date(element.memberdob);
          });

          this.http.get(bmxurl + "membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
            this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.ListMemberships = (response as membership_returndata).data;

              this.ListMemberships.forEach(m => {
                if(m.membershiptypeid  == this.thisMembershipSale.membershiptypeid)
                {
                  this.selectedMembership = m;
                }
              });
              if ((response as membership_returndata).messages.length > 0)
              {
                (response as membership_returndata).messages.forEach(error => {
                  this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
                });
              }
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
          });
        }
        , error => {
          this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting membership, error:' + error.messages[0]});
        });

      this.CompletedLoading = true;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
      });

    }
  }, error => {
    this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
  });

}

  DatifyString(date: string): Date
  {
    let returnDate = new Date();

    returnDate.setUTCFullYear(Number(date.substring(0, 4)));
    returnDate.setUTCMonth(Number(date.substring(5, 7)) - 1);
    returnDate.setUTCDate(Number(date.substring(8, 10)));
    returnDate.setUTCHours(0);
    returnDate.setUTCMinutes(0);
    returnDate.setUTCSeconds(0);

    return returnDate;
  }

  applyCustomer(passCustomer)
  {
    this.ShowCustomerDetails = true;
    this.firstName = passCustomer.firstName;
    this.lastName = passCustomer.lastName;
    this.address1 = passCustomer.address1;
    this.address2 = passCustomer.address2;
    this.town = passCustomer.townCity;
    this.postCode = passCustomer.postCode;
    this.email = passCustomer.email;
    this. mobile = passCustomer.mobile;

    this.customersResult = null;
    this.searchCriteria = "";

  }

  searchCustomer(){
    this.http.get(bmxurl + "customer/search/" + this.VenueID + "/" + this.searchCriteria).subscribe(response => {
      this.customersResult = (response as customer[])
    }, error => {
    })

  }

  showCustomerSearch()
  {
    this.ShowCustomerSearch = true;
    this.CustomerHasBeenEdited = true;
  }

  toggleMore(inDiv)
  {
    let collapsedDiv = document.getElementById(inDiv + "collapse") as HTMLElement;
    let expandeddDiv = document.getElementById(inDiv + "expanded") as HTMLElement;
    let toggleButton = document.getElementById(inDiv + "toggleButton") as HTMLButtonElement;

    if(collapsedDiv.hidden == true)
    {
      collapsedDiv.hidden = false
      collapsedDiv.style.display = "false";
    }
    else
    {
      collapsedDiv.hidden = true
      collapsedDiv.style.display = "true";
    }

    if(expandeddDiv.hidden == true)
    {
      expandeddDiv.hidden = false
      expandeddDiv.style.display = "false";
    }
    else
    {
      expandeddDiv.hidden = true
      expandeddDiv.style.display = "true";
    }

    if(toggleButton.value == "Show More...")
    {
      toggleButton.value = "Show Less..."
      toggleButton.textContent = "Show Less..."
    }
    else
    {
      toggleButton.value = "Show More..."
      toggleButton.textContent = "Show More..."
    }
  }

  // updateCustomer()
  // {
  //   this.CustomerAllValid = true;

  //   if(this.ProvideMinimalPersonalData)
  //   {
  //     if (this.thisMembershipSale.customer.lastName == "") {
  //       this.CustomerAllValid = false;
  //       this.lastNameEditValid = false;
  //     }
  //     else {
  //       this.lastNameEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.email == "") {
  //       this.CustomerAllValid = false;
  //       this.EmailEditValid = false;
  //     }
  //     else {
  //       this.EmailEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.mobile == "") {
  //       this.CustomerAllValid = false;
  //       this.MobileEditValid = false;
  //     }
  //     else {
  //       this.MobileEditValid = true;
  //     }
  //   }
  //   else
  //   {
  //     if (this.thisMembershipSale.customer.firstName == "") {
  //       this.CustomerAllValid = false;
  //       this.firstNameEditValid = false;
  //     }
  //     else {
  //       this.firstNameEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.lastName == "") {
  //       this.CustomerAllValid = false;
  //       this.lastNameEditValid = false;
  //     }
  //     else {
  //       this.lastNameEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.address1 == "") {
  //       this.CustomerAllValid = false;
  //       this.Address1EditValid = false;
  //     }
  //     else {
  //       this.Address1EditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.townCity == "") {
  //       this.CustomerAllValid = false;
  //       this.TownEditValid = false;
  //     }
  //     else {
  //       this.TownEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.postCode == "") {
  //       this.CustomerAllValid = false;
  //       this.PostCodeEditValid = false;
  //     }
  //     else {
  //       this.PostCodeEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.email == "") {
  //       this.CustomerAllValid = false;
  //       this.EmailEditValid = false;
  //     }
  //     else {
  //       this.EmailEditValid = true;
  //     }

  //     if (this.thisMembershipSale.customer.mobile == "") {
  //       this.CustomerAllValid = false;
  //       this.MobileEditValid = false;
  //     }
  //     else {
  //       this.MobileEditValid = true;
  //     }
  //   }

  //   //Check for valid email and mobile

  //   if (this.thisMembershipSale.customer.email != "") {
  //     if (!this.validateEmail(this.thisMembershipSale.customer.email)) {
  //       this.CustomerAllValid = false;
  //       this.EmailFormatEditValid = false;
  //     }
  //     else {
  //       this.EmailFormatEditValid = true;
  //     }
  //   }

  //   if(this.thisMembershipSale.customer.mobile != ""){
  //     if (!this.validateMobile(this.thisMembershipSale.customer.mobile)) {
  //       this.CustomerAllValid = false;
  //       this.MobileFormatEditValid = false;
  //     }
  //     else {
  //       this.MobileFormatEditValid = true;
  //     }
  //   }
    
  //   if(this.CustomerAllValid == true)
  //   {
  //     let newCustomer: Customer = {
  //       id: this.thisMembershipSale.customer.id,
  //       customerid:  this.thisMembershipSale.customer.customerid,
  //       firstName:  this.thisMembershipSale.customer.firstName,
  //       lastName:  this.thisMembershipSale.customer.lastName,
  //       fullName:  this.thisMembershipSale.customer.firstName + " " + this.thisMembershipSale.customer.lastName,
  //       address1:  this.thisMembershipSale.customer.address1,
  //       address2:  this.thisMembershipSale.customer.address2,
  //       townCity:  this.thisMembershipSale.customer.townCity,
  //       postCode:  this.thisMembershipSale.customer.postCode,
  //       email: this.thisMembershipSale.customer.email,
  //       mobile: this.thisMembershipSale.customer.mobile,
  //       dob: this.thisMembershipSale.customer.dob,
  //       venueId: this.VenueID,
  //       disabled: false,
  //       bookingid: null

  //     }

  //     this.http.put<string>(bmxurl + "/customer", newCustomer).subscribe(response => {
  //       this.BookingResponse = response 
  //       if(this.BookingResponse.succeeded)
  //       {
  //         this.NewBooking = this.BookingResponse.data;
  //         this.dosummary();

  //         this.messageService.add({severity:'success', summary:'Success', detail:'Customer updated' });

  //         this.ShowSaveButton = false;
  //       }
  //       else{
  //         this.messageService.add({severity:'error', summary:'Failure', detail:'This Customer could not be updated' });
  //       }
  //     }, error => {
  //       this.messageService.add({severity:'error', summary:'Failure', detail:'This Customer could not be updated' });
  //     })
  //   }
  // }

  Checkfortoday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  doneCustomer()
  {
    this.CustomerAllValid = true;

    if(this.ProvideMinimalPersonalData)
    {
      if (this.thisMembershipSale.customer.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameEditValid = false;
      }
      else {
        this.firstNameEditValid = true;
      }

      if (this.thisMembershipSale.customer.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameEditValid = false;
      }
      else {
        this.lastNameEditValid = true;
      }

      if (this.thisMembershipSale.customer.email == "") {
          this.CustomerAllValid = false;
          this.EmailEditValid = false;
      }
      else {
        this.EmailEditValid = true;
      }

      if (this.thisMembershipSale.customer.mobile == "") {
          this.CustomerAllValid = false;
          this.MobileEditValid = false;
      }
      else {
        this.MobileEditValid = true;
      }
    }
    else
    {
      if (this.thisMembershipSale.customer.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameEditValid = false;
      }
      else {
        this.firstNameEditValid = true;
      }

      if (this.thisMembershipSale.customer.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameEditValid = false;
      }
      else {
        this.lastNameEditValid = true;
      }

      if (this.thisMembershipSale.customer.address1 == "") {
        this.CustomerAllValid = false;
        this.Address1EditValid = false;
      }
      else {
        this.Address1EditValid = true;
      }

      if (this.thisMembershipSale.customer.townCity == "") {
        this.CustomerAllValid = false;
        this.TownEditValid = false;
      }
      else {
        this.TownEditValid = true;
      }

      if (this.thisMembershipSale.customer.postCode == "") {
        this.CustomerAllValid = false;
        this.PostCodeEditValid = false;
      }
      else {
        this.PostCodeEditValid = true;
      }

      if (this.thisMembershipSale.customer.email == "") {
        this.CustomerAllValid = false;
        this.EmailEditValid = false;
      }
      else {
        this.EmailEditValid = true;
      }

      if (this.thisMembershipSale.customer.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileEditValid = false;
      }
      else {
        this.MobileEditValid = true;
      }
    }


    //Check for valid email and mobile

    if (this.thisMembershipSale.customer.email != "") {
      if (!this.validateEmail(this.thisMembershipSale.customer.email)) {
        this.CustomerAllValid = false;
        this.EmailFormatEditValid = false;
      }
      else {
        this.EmailFormatEditValid = true;
      }
    }

    if(this.thisMembershipSale.customer.mobile != ""){
      if (!this.validateMobile(this.thisMembershipSale.customer.mobile)) {
        this.CustomerAllValid = false;
        this.MobileFormatEditValid = false;
      }
      else {
        this.MobileFormatEditValid = true;
      }
    }

    if(this.CustomerAllValid == true)
    {
    //   let newCustomer: Customer = {
    //     id: null,
    //     customerid: null,
    //     firstName: this.firstName,
    //     lastName: this.lastName,
    //     fullName: this.firstName + " " + this.lastName,
    //     address1: this.address1,
    //     address2: this.address2,
    //     townCity: this.town,
    //     postCode: this.postCode,
    //     email: this.email,
    //     mobile: this.mobile,
    //     dob: this.dob,
    //     venueId: this.VenueID,
    //     disabled: true,
    //     bookingid: null
    //   }

    //   this.thisMembershipSale.customer = newCustomer;

      this.thisMembershipSale.customer.fullName = this.thisMembershipSale.customer.firstName + " " + this.thisMembershipSale.customer.lastName;
      this.savemembershipsale(false);
    
    }
  }

  removeMember(index: number)
  {
    this.SelectedAdmissions.splice(index, 1);
    this.Total = 0;

    // this.SelectedAdmissions.forEach(adm => {
    //   this.totalPayments += adm.price * adm.numberofadmissions;
    // });
  }


  validateEmail(email){ 
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }

  validateMobile(mobile){ 
    var re = /^(\+44\s?|0)7\d{9}$/; 
    return re.test(mobile); 
  }

  deferPayment(){
    this.showDeferReason = true;
  }

  DoSummary(BookingSummary){
    this.MembershipComplete = true;
  }

  makeNewPayment()
  {
    this.AllValid = true;

    if (this.validPaymentAmount == null || (this.validPaymentAmount < 0)) {
      this.AllValid = false;
      this.paymentValueValid = false;
    }
    else {
      this.paymentValueValid = true;
    }

    if (this.selectedPayment == null) {
      this.AllValid = false;
      this.paymentTypeValid = false;
    }
    else {
      this.paymentTypeValid = true;
    }

    if(this.AllValid)
    {
      this.donePayment(this.selectedPayment.id, this.selectedPayment.name);
    }
  }

  donePayment(paymentid: string, paymentname : string)
  {

    this.paymentButtonLocked = true;

    this.AllValid = true;

    if (this.validPaymentAmount == null || (this.validPaymentAmount < 0)) {
      this.AllValid = false;
      this.paymentValueValid = false;
    }
    else {
      this.paymentValueValid = true;
      this.AllValid = true;
    }

    if(this.AllValid)
    {
      let newPayment: Payment = {
        id: null,
        PaymentId: null,
        BookingId: null,
        bookingIdHR: null,
        method: paymentname,
        paymenttypeid: paymentid,
        amount: this.validPaymentAmount,
        paymentDate: new Date,
        disabled: false,
        venueid: this.VenueID,
        refunds: null,
        balance: this.validPaymentAmount,
        paymenttype: "membership",
        currency: this.CurrencySymbol,
        tillname: null
      }

      if (this.thisMembershipSale.payments == null) {
        this.thisMembershipSale.payments = [];
      }

      this.thisMembershipSale.payments.push(newPayment);

      this.stampMembershipIdOnMembers();

      this.http.post<booking_returndata>(bmxurl + "/membership", this.thisMembershipSale).subscribe(response => {
        this.MembershipResponse = (response as any).data
        
        if(response.succeeded == true)
        {
          //A partial payment leaves money owing, so the panel has to be rebuilt from the
          //sale that comes back - it used to keep the pre-payment figures, which left the
          //amount owed and the payments table stale and the Add Payment button locked.
          this.applyUpdatedSale(this.MembershipResponse);
          this.refreshSaleFromServer();

          this.selectedPayment = null;
          this.paymentButtonLocked = false;
          this.paymentValueValid = true;
          this.paymentTypeValid = true;

          this.messageService.add({severity:'success', summary:'Payment Added', detail: this.amountOwed > 0 ? 'Payment added, still to pay: ' + this.amountOwed.toFixed(2) : 'Payment added, this sale is now paid in full.'});

          //create membership summary
          this.membershipSummary.PIN = this.MembershipResponse.membershippin;
          this.membershipSummary.membershipidhr = this.MembershipResponse.salesid;
          this.membershipSummary.startTime = this.MembershipResponse.startdate;
          this.membershipSummary.endTime = this.MembershipResponse.enddate;

          let memTypeID = this.MembershipResponse.membershiptypeid;

          this.ListMemberships.forEach(m => {
            if(m.id == memTypeID)
            {
              this.membershipSummary.membershipType = m.name;
            }
         });

          this.membershipSummary.admissions = "";
          this.MembershipResponse.memberships.forEach(adm => {
            this.membershipSummary.admissions += adm.membername + " (" + new Date(adm.memberdob).toLocaleDateString().padStart(10, '0') + "), ";
          });

          this.membershipSummary.admissions = this.membershipSummary.admissions.substring(0, this.membershipSummary.admissions.length - 2);

          this.membershipSummary.customerName = this.MembershipResponse.customer.firstName + " " + this.MembershipResponse.customer.lastName;
          this.membershipSummary.customerAddress = this.MembershipResponse.customer.address1 + " " + this.MembershipResponse.customer.address2 + "\n" + this.MembershipResponse.customer.townCity + "\n" + this.MembershipResponse.customer.postCode;

          this.membershipSummary.customerMobile = this.MembershipResponse.customer.mobile;
          this.membershipSummary.customerEmail = this.MembershipResponse.customer.email;

          this.membershipSummary.paid = this.totalPaid;
        }
        else
        {
          //The payment was not taken, so drop it again - leaving it on the sale would send
          //it a second time on the next attempt.
          this.removeUnsavedPayment(newPayment);
          this.messageService.add({severity:'error', summary:'Error', detail: response.messages});
          this.paymentButtonLocked = false;
        }
      }, error => {
        this.removeUnsavedPayment(newPayment);
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
        this.paymentButtonLocked = false;
      })
    }
  }

  private removeUnsavedPayment(payment: Payment): void {
    if (this.thisMembershipSale?.payments == null) {
      return;
    }

    let index = this.thisMembershipSale.payments.indexOf(payment);

    if (index > -1) {
      this.thisMembershipSale.payments.splice(index, 1);
    }
  }

  sendSMSConfirmation(){
     this.http.get<customer>(bmxurl + "confirmation/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'SMS Message sent.'});
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the SMS'});
     })
  }

  sendEmailConfirmation(){
     this.http.get<customer>(bmxurl + "sendmembershipemail/" + this.VenueID + "/" + this.httpMembershipResponse.data.membershipid + "/" + this.membershipEmailTemplateID).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
     })
  }

  returnHome(){
    this.BookingPayments = [];
    this.Total = 0;

    this.checked = [];

    this.BookingComplete = false;

    this.PackageHeader = "Select a Package";
    this.CalendarHeader = "Select a Date";
    this.AdmissionHeader = "Select your Admissions";
    this.TimeHeader = "Select a Time";
    this.CustomerHeader = "Create a Customer";
    this.PaymentHeader = "Add a Payment";
    this.ExtrasHeader = "Select Extras";

    this.startTimes = null;
    this.startTimesFiltered = null;

    this.SelectedPackage = null;
    this.SelectedDate = null;

    this.firstName = "";
    this.lastName = "";
    this.address1 = "";
    this.address2 = "";
    this.town = "";
    this.postCode = "";
    this.email = "";
    this.mobile = "";
    this.searchCriteria = "";
    this.customersResult = null;
    this.ShowCustomerDetails = false;

    this.selectedPayment = null;
    this.packageExtras = null;
    this.paymentAmount = 0;
    this.makeABookingHeader = "Make a Booking";
    this.thisMembershipSale = {} as membershipsale;
    this.customerSelectedResources = [];
    this.SelectedResources = [];

    this.MinimumValidPayment = 0;
  }
  
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addMs = (date: Date, ms: number): Date => {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + ms);
    return result;
  };

  printConfirmation()
  {
    this.showPrintConfirmations = true;
    this.http.get(bmxurl + "print/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
      this.confHTML = (response as conf_returndata).data.toString();
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })

  }

}



